// HoldInvoiceWasAccepted.tsx: the ONE celebration for an accepted hold
// payment (setOurInvoices skips hold rows so it does not confetti twice)
import { observer } from "mobx-react";
import React from "react";
import { Modal } from "@mantine/core";
import PaidNotificationDesign from "./helpers/PaidSuccessfulNotificationDesign";
import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import { BOB_MODALS } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import { holdAmountSatoshis } from "../../helpers/holdInvoices";

const HoldInvoiceWasAccepted = observer(({ bob }: { bob: Bob }) => {
  const hold = bob.holdInvoices.data.find(
    (h) => h.uuid === bob.celebratedHoldUuid,
  );
  const handleClose = () => {
    bob.setOpenModal(null);
    bob.setCelebratedHoldUuid(null);
  };
  if (!hold) return null;
  const sats = holdAmountSatoshis(hold);

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.HOLD_INVOICE_WAS_ACCEPTED}
      onClose={handleClose}
      size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      radius="md"
      withCloseButton={false}
      overlayProps={{ blur: 0.8 }}
    >
      <PaidNotificationDesign
        title="Payment accepted!"
        satoshis={sats}
        fiat={bob.formatFiat(sats)}
        onClick={handleClose}
      />
    </Modal>
  );
});

export default HoldInvoiceWasAccepted;
